import { types } from 'mobx-state-tree';

import ProductPriceInfo from './ProductPriceInfo';

const Ad = types.model('Ad', {
  id: types.identifier,
  content: types.maybeNull(types.string),
  link_url: types.maybeNull(types.string),
  title: types.maybeNull(types.string),
  image: types.maybeNull(types.string),
  hide_from_desktop_tablet_users: types.maybeNull(types.boolean),
  mobile_image: types.maybeNull(types.string),
  hide_from_mobile_users: types.maybeNull(types.boolean),
  price_info: types.maybeNull(ProductPriceInfo),
  discount_text: types.maybeNull(types.string),
  overlay_background_color: types.maybeNull(types.string),
  text_color: types.maybeNull(types.string),
  overlay_image: types.maybeNull(types.string),
  scent: types.maybeNull(types.string),
  priority: types.number,
  manufacturer: types.maybeNull(types.string),
  product_id: types.maybeNull(types.string),
  // This refers to the possible product, not the banner itself.
  date_added: types.maybeNull(types.string)
});

export default Ad;



// WEBPACK FOOTER //
// ./src/models/Ad.js